module.exports = __webpack_public_path__ + "static/media/refresh_icon.aae49de0.svg";